import { useDispatch, useSelector } from "react-redux";
import { setSessionExpired, setSpinnerLoading } from "../utility/Redux/modal";
import { useState } from "react";
import { selectToken } from "../utility/Redux/security";
import { useEffect } from "react";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import MasterHelp from "../utility/component/modals/masterHelp";
import { CallAPIPromise } from "../billing/common";

const BalanceSheethelp = ({
  onRowClick,
  status,
  onClose,
  setItemMasterHelpStatus,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "80%",
    width: "auto",
    padding: "2px",
    borderRadius: "8px",
    // Change the shadow color
    overflow: "hidden",
    backgroundColor: "white",
  };

  const [rows, setRows] = useState([]);
  const token = useSelector(selectToken);
  const [barcode, setBardCode] = useState("");
  const prefix = useSelector(selectPrefix);

  const windowWidth = useSelector(selectWidth);
  const columns = [
    {
      field: "HEAD_NO",
      type: "string",
      renderHeader: (params) => <div>Head No.</div>,
      width: windowWidth > 768 ? 80 : 260,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => {
        return <div className="hover:cursor-text w-full">{params.value}</div>;
      },
    },
    {
      field: "HEAD",
      type: "string",
      renderHeader: (params) => <div>Head </div>,
      width: windowWidth > 768 ? 190 : 260,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => {
        return <div className="hover:cursor-text w-full">{params.value}</div>;
      },
    },
    {
      field: "UNDER_HEAD",
      type: "string",
      renderHeader: (params) => <div>Under Head</div>,
      width: windowWidth > 768 ? 150 : 260,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => {
        return <div className="hover:cursor-text w-full">{params.value}</div>;
      },
    },

    {
      field: "UNDER_SUB_HEAD",
      type: "string",
      renderHeader: (params) => <div>Under Sub Head</div>,
      width: windowWidth > 768 ? 150 : 260,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => {
        return <div className="hover:cursor-text w-full">{params.value}</div>;
      },
    },
    {
      field: "ROOT_HEAD",
      type: "string",
      renderHeader: (params) => <div>Root Head</div>,
      width: windowWidth > 768 ? 100 : 260,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => {
        return <div className="hover:cursor-text w-full">{params.value}</div>;
      },
    },
  ];

  const [searchQuery, setSearchQuery] = useState("");
  const [fullList, setFullList] = useState([]);

  useEffect(() => {
    if (searchQuery) {
      const regex = /\d+/;

      const searchItems = fullList.filter((item) => {
        if (regex.test(searchQuery.substring(0, 1))) {
          return item.HEAD_NO.toString().includes(searchQuery);
        } else {
          return item.HEAD.toLowerCase().includes(searchQuery.toLowerCase());
        }
      });

      setRows(searchItems);
    } else {
      setRows(fullList);
    }
  }, [searchQuery]);

  const dispatch = useDispatch();

  const getData = async () => {
    dispatch(setSpinnerLoading("Loading bill"));
    const data = {
      table_prefix: prefix,
    };
    CallAPIPromise("/api/accountMaster/listBalancesheetHead", data, token)
      .then((p) => {
        if (p.data.response.data[0]) {
          let list = [];
          const data = p.data.response.data;
          for (let i = 0; i < data.length; i++) {
            list.push({
              ...data[i],
              id: i + 1,
            });
          }
          setFullList(list);
          setRows(list);
        }
      })
      .catch((error) => {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    if (status) {
      getData();
    }
  }, [status]);

  const width = useSelector(selectWidth);
  return (
    <>
      <div className="bg-white">
        <MasterHelp
          status={status}
          style={style}
          onClose={() => {
            setSearchQuery("");
            onClose();
            setRows([]);
          }}
          title={"Balance Sheet Head | Help"}
          columns={columns}
          list={rows}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onRowClick={(p) => {
            setSearchQuery("");

            onRowClick(p);
            setRows([]);
          }}
        />
      </div>
    </>
  );
};

export default BalanceSheethelp;
